import PSPDFKitWeb from 'pspdfkit';
import { Selection } from 'components/pspdf/components/selection';
import { CustomMarkupMenu } from 'components/pspdf/components/markup-menu/index';
import { hideNameEditor } from 'components/pspdf/components/snippet-name-editor/actions';

const CUSTOM_OVERLAY_ID = 'CortlexInlineMarkupToolbar';

interface ShowMarkupMenuInput {
  selectedAnnotation: { current: any };
  instance: any;
  markupMenuRenderer: Function;
}

interface HideMarkupMenuInput {
  instance: any;
}

export async function showMarkupMenu({
  selectedAnnotation,
  instance,
  markupMenuRenderer,
}: ShowMarkupMenuInput) {
  if (selectedAnnotation) {
    const entity = new Selection(selectedAnnotation, instance);
    const selection = await entity.getRect();
    const position = calculatePosition(selection.rect);

    const element = {
      id: CUSTOM_OVERLAY_ID,
      node: CustomMarkupMenu(markupMenuRenderer()),
      position: position,
      pageIndex: selection.pageIndex,
    };

    element.node.classList.remove('Cortlex-Hidden');
    element.node.classList.add('cortlex-markup-menu');

    setTimeout(() => {
      const [element] =
        instance.contentDocument.getElementsByClassName(
          'cortlex-markup-menu',
        ) ?? [];

      if (element && element?.parentElement?.parentElement) {
        const parentParent = element?.parentElement
          ?.parentElement as HTMLElement;

        if (parentParent) {
          parentParent.style.position = 'fixed';
        }
      }
    });

    instance.setCustomOverlayItem(new PSPDFKitWeb.CustomOverlayItem(element));
  }
}

export function hideMarkupMenu({ instance }: HideMarkupMenuInput) {
  // Wrapping markup toolbar destruction inside a setTimeout function
  // prevents an issue where text selection mode is triggered
  setTimeout(() => {
    // We don't care if the item doesn't exist anymore
    try {
      hideNameEditor({ instance });
      instance.removeCustomOverlayItem(CUSTOM_OVERLAY_ID);
    } catch {
      // TODO
    }
  }, 0);
}

function calculatePosition(rect) {
  const position = rect.getLocation();
  console.log("POSITION", rect)
  const newY = position.y > 60 ? position.y - 80 : position.y + 40 

  return new PSPDFKitWeb.Geometry.Point({
    x: position.x + rect.width / 2 - 126,
    y: newY,
  });
}
